import { IonInput } from '@ionic/angular';

export function focusOnInput(input: IonInput) {
  setTimeout(() => {
    if (input) {
      input.setFocus();
    }
  }, 200);
}

export function focusOnPhoneNumber(phoneNumber: any, timeout?: number) {
  setTimeout(() => {
    if (phoneNumber) {
      phoneNumber.focus();
    }
  }, timeout || 200);
}
